import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/fonts.css';
import './i18n';

// Load schema testing utilities in development
if (import.meta.env.DEV) {
  import('./utils/testSchema');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);